import React from "react";

import { VersionList as VersionListRoot } from "./VersionList";
import { VersionListItem } from "./VersionListItem";

interface IVersionList extends React.FC<{ children: React.ReactNode }> {
  Item: typeof VersionListItem;
}

const VersionList: IVersionList = (props) => <VersionListRoot {...props} />;
VersionList.Item = VersionListItem;

export { VersionList };
